import React from "react";
import Select from "react-select";
import "./UserModal.css";
import { surveyapi } from "../../APIs/API";
import { getParameterByName, token } from "../../Utils/Function";
import { surveyurl } from "../../Utils/Bootstrap";
import { monthNames, languageList } from "../../Utils/Helper";
import $ from "jquery";
import ImageuploadPopup from "../ImageuploadPopup";

const countryNames = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo",
  "Costa Rica",
  "Côte d'Ivoire",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "North Korea",
  "South Korea",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Lithuania",
  "Luxembourg",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syria",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export default class UserModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: { value: "en", label: "English" },
      name: null,
      mobile: null,
      address: null,
      city: null,
      state: null,
      zip: null,
      country: { value: "India", label: "India" },
      stateobj: null,
      countryname: "India",
      stateid: null,
      lengthres: null,
      // state: [],
      // vsabha: [],
      state: null,
      vsabha: null,
      boothno: null,
      stateList: [],
      vsabhaList: [],
      boothList: [],
      countryList: [],
      profileimage: "",
      visible: false,
      flag: "0",

      errors: {
        name: "",
        mobile: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        profileimage: "",
      },
      formErrors: [],
    };
  }

  componentDidMount() {
    this.getStateList();
    this.getUserDetails();
    let countryListArr = [];
    countryNames &&
      countryNames.map((data) => {
        countryListArr.push({ value: data, label: data });
      });
    this.setState({ countryList: countryListArr });
  }

  componentWillUnmount() {}

  validateField = (fieldName, value) => {
    let error = "";

    switch (fieldName) {
      case "name":
        if (!value || value.trim() === "") {
          error = "Please enter your name";
        } else if (value.trim().length < 2) {
          error = "Name must be at least 2 characters long";
        }
        break;

      case "mobile":
        if (!value || value.trim() === "") {
          error = "Please enter your mobile number";
        } else if (!this.validatePhoneNumber(value)) {
          error = "Please enter a valid mobile number";
        }
        break;

      case "address":
        if (!value || value.trim() === "") {
          error = "Please enter your address";
        } else if (value.trim().length < 8) {
          error = "Address must be at least 8 characters long";
        }
        break;

      case "city":
        if (!value || value.trim() === "") {
          error = "Please enter your city";
        }
        break;

      case "state":
        if (
          !value ||
          (typeof value === "string" && value.trim() === "") ||
          (typeof value === "object" && !value.value)
        ) {
          error = "Please select/enter your state";
        }
        break;

      case "zip":
        if (!value || value.toString().trim() === "") {
          error = "Please enter your zip code";
        } else if (value.toString().length !== 6) {
          error = "Please enter a 6-digit zip code";
        }
        break;

      case "country":
        if (!value || !value.value) {
          error = "Please select your country";
        }
        break;

      case "profileimage":
        if (!value || value.trim() === "") {
          error = "Please upload your profile image";
        }
        break;

      default:
        break;
    }

    return error;
  };

  updateFieldStyle = (elementId, error) => {
    const element = document.getElementById(elementId);
    if (element) {
      if (error) {
        element.style.borderColor = "red";
      } else {
        element.style.borderColor = "green";
      }
    }
  };

  getProfile = (image) => {
    this.setState({ profileimage: image }, () => {
      const error = this.validateField("profileimage", image);
      this.setState((prevState) => ({
        errors: { ...prevState.errors, profileimage: error },
      }));
      this.updateFieldStyle("userImage", error);
    });
  };

  hideImgpopup = () => {
    this.setState({ visible: false });
  };

  flagpopup = (flag) => {
    this.setState({ flag: flag });
  };

  handleClick = () => {
    this.setState({ visible: true });
  };

  handleChange = async (val, type) => {
    this.setState({ [type]: val });
    if (type === "lang") {
      this.getStateList();
      this.props.getDetailsData(val.value);
    }
    if (type == "country") {
      this.setState(
        {
          countryname: val.value,
        },
        () => {
          const error = this.validateField("country", val);
          this.setState((prevState) => ({
            errors: { ...prevState.errors, country: error },
          }));
        }
      );
    }
    if (type == "stateobj") {
      this.setState(
        {
          statename: val.label,
          adstateid: val.value,
        },
        () => {
          const error = this.validateField("state", val);
          this.setState((prevState) => ({
            errors: { ...prevState.errors, state: error },
          }));
          this.updateFieldStyle("state", error);
        }
      );
    }
    if (type === "state") {
      this.getVidhansabhaList(val.value);
    }
  };

  getUserDetails = async () => {
    let userid = await getParameterByName("userid");
    if (!userid) {
      return null;
    }
    let data = new FormData();
    data.append("action", "getuserdetail");
    data.append("userid", userid);
    data.append("addressid", userid);
    data.append("quiz_token", localStorage.getItem("quiz_token"));
    let surveyapicall = surveyapi.survey(data, surveyurl);
    let thisVar = this;
    surveyapicall.done((response) => {
      let resObj = JSON.parse(response);
      let resp = resObj && resObj ? resObj : null;

      if (resp && resp.user_name_display) {
        let name = resp.user_name_display;
        let user_avatar = resp.user_avatar || "";
        let mobile = resp.user_contact_no || null;
        let address = resp.address || null;
        let boothno = resp.booth || null;

        let state = {
          value: resp.state_id, // Use state_id for value
          label: resp.state_name, // Use state_name for label
        };
        // let stateobj = {
        //   value: resp.state_id, // Use state_id for value
        //   label: resp.state_name, // Use state_name for label
        // };

        let vsabha = {
          value: resp.vshabha_id || null, // Use vsabha_id if available
          label: resp.vshabha_name || null,
        };
        thisVar.setState(
          {
            name: name,
            mobile: mobile,
            profileimage: user_avatar,
            address: address,
            boothno: boothno,
            state: state,
            // stateobj: stateobj,
            // statename: resp.state_name,
            // adstateid: resp.state_id,
            vsabha: vsabha,
          },
          () => {
            // Validate prepopulated data and clear errors for valid fields
            const validationErrors = {};

            // Validate each prepopulated field
            const nameError = thisVar.validateField("name", name);
            if (nameError) validationErrors.name = nameError;

            const mobileError = thisVar.validateField("mobile", mobile);
            if (mobileError) validationErrors.mobile = mobileError;

            const addressError = thisVar.validateField("address", address);
            if (addressError) validationErrors.address = addressError;

            const profileError = thisVar.validateField(
              "profileimage",
              user_avatar
            );
            if (profileError) validationErrors.profileimage = profileError;

            // Update errors state with only the errors that exist
            thisVar.setState({ errors: validationErrors });

            // Update field styles for prepopulated data
            if (name) thisVar.updateFieldStyle("userName", nameError);
            if (mobile) thisVar.updateFieldStyle("numbers", mobileError);
            if (address) thisVar.updateFieldStyle("residence", addressError);
            if (user_avatar)
              thisVar.updateFieldStyle("userImage", profileError);
          }
        );
        this.getVidhansabhaList(state.value);
      }
    });
  };
  getFormData = async (action, sid = null) => {
    let data = new FormData();
    let userid = await getParameterByName("userid");
    data.append("action", action);
    if (userid) {
      data.append("userid", userid);
      data.append("addressid", userid);
    } else {
      data.append("token", token);
    }
    if (sid) {
      data.append("state_id", sid);
    }
    data.append("quiz_token", localStorage.getItem("quiz_token"));
    data.append("lang", this.state.lang.value);

    let surveyapicall = surveyapi.survey(data, surveyurl);
    surveyapicall.done((response) => {
      let resObj = JSON.parse(response);
      // if (resObj._resultflag === "1")
      if (action === "getstatelist") {
        let stateListArr = [];
        resObj.data &&
          resObj.data.map((data) => {
            stateListArr.push({ value: data.stateid, label: data.statename });
          });
        this.setState({ stateList: stateListArr });
      } else if (action === "getvidhansabhalist") {
        let vsabhaListArr = [];
        resObj.data &&
          resObj.data.map((data) => {
            vsabhaListArr.push({ value: data.vs_id, label: data.vs_name });
          });
        this.setState({ vsabhaList: vsabhaListArr });
      }
      // }
    });
  };

  getStateList = async () => {
    await this.getFormData("getstatelist");
  };
  getVidhansabhaList = async (sid) => {
    await this.getFormData("getvidhansabhalist", sid);
  };

  validatePhoneNumber = (inputtxt) => {
    var phoneno = /^(0|91|\+91)?-?[789]\d{9}$/;
    // var phoneno = /^\+(?:[0-9] ?){6,14}[0-9]$/;
    if (inputtxt.match(phoneno)) {
      return true;
    } else {
      return false;
    }
  };
  onSubmit = async () => {
    let {
      name,
      mobile,
      city,
      statename,
      zip,
      countryname,
      adstateid,
      address,
      state,
      vsabha,
      boothno,
      lang,
      profileimage,
      flag,
    } = this.state;

    // Validate all required fields
    const validationErrors = {};
    const formErrors = [];

    // Validate each field
    const nameError = this.validateField("name", name);
    if (nameError) {
      validationErrors.name = nameError;
      formErrors.push(nameError);
    }

    const mobileError = this.validateField("mobile", mobile);
    if (mobileError) {
      validationErrors.mobile = mobileError;
      formErrors.push(mobileError);
    }

    const addressError = this.validateField("address", address);
    if (addressError) {
      validationErrors.address = addressError;
      formErrors.push(addressError);
    }

    const cityError = this.validateField("city", city);
    if (cityError) {
      validationErrors.city = cityError;
      formErrors.push(cityError);
    }

    const stateError = this.validateField(
      "state",
      this.state.country.value === "India" ? this.state.stateobj : statename
    );
    if (stateError) {
      validationErrors.state = stateError;
      formErrors.push(stateError);
    }

    const zipError = this.validateField("zip", zip);
    if (zipError) {
      validationErrors.zip = zipError;
      formErrors.push(zipError);
    }

    const countryError = this.validateField("country", this.state.country);
    if (countryError) {
      validationErrors.country = countryError;
      formErrors.push(countryError);
    }

    const profileError = this.validateField("profileimage", profileimage);
    if (profileError) {
      validationErrors.profileimage = profileError;
      formErrors.push(profileError);
    }

    // Update state with validation errors
    this.setState({
      errors: validationErrors,
      formErrors: formErrors,
    });

    // If there are any errors, don't proceed
    if (formErrors.length > 0) {
      return;
    }

    // If validation passes, proceed with form submission
    localStorage.setItem("userName", name);
    localStorage.setItem("lang", lang.value);
    let karyakartas = {
      state: state.label || null,
      vsabha: vsabha.label || null,
      boothno: boothno || null,
    };
    localStorage.setItem("karyakartas", JSON.stringify(karyakartas));

    if (lang.value === "hi") {
      await this.props.getDetailsData(lang.value);
    }

    let userid = await getParameterByName("userid");
    let quizid = await getParameterByName("quizid");

    let data = new FormData();
    data.append("action", "postuserquiz");
    data.append("survey_id", quizid);
    data.append("platform", "pwa");

    if (userid) {
      data.append("userid", userid);
      data.append("addressid", userid);
    } else {
      data.append("token", token);
    }
    data.append("quiz_token", localStorage.getItem("quiz_token"));

    let userDatails = {
      name: name,
      mobile: mobile,
      address: address,
      adcity: city,
      adcountry: countryname,
      adzipcode: zip,
      adstate: statename,
      adstateid: adstateid,
      state: state,
      vsabha: vsabha,
      boothno: boothno,
      lang: lang,
      is_profileupdate: flag,
      profileimage: profileimage,
    };
    data.append("userDetails", JSON.stringify(userDatails));

    try {
      let users = surveyapi.survey(data, surveyurl);
      let thisVar = this;
      users.done((response) => {
        let resObj = JSON.parse(response);
        if (resObj._resultflag === "1") {
          thisVar.props.hideModal();
          thisVar.clearFormErrors();
        }
      });
    } catch (error) {
      console.log("error", error);
    }
  };
  render() {
    const {
      stateList,
      vsabhaList,
      state,
      vsabha,
      lang,
      langList,
      visible,
      profileimage,
      errors,
      formErrors,
    } = this.state;
    const { title, complete_msg, survey_desc } = this.props;
    let d = new Date();
    let month = monthNames[d.getMonth()];
    let year = d.getFullYear();
    return (
      <div className="container-fluid">
        <div className="modal_overlay">
          <div className="modal_body">
            {/* <div className="close_btn" onClick={this.props.hideModal}><img src="assets/images/close_white.svg" /></div> */}
            <h3 className="mkb_head">
              {title || `Mann Ki Baat 2024 September`}
            </h3>
            <div className="img_up_div">
              <img
                onClick={this.handleClick}
                id="userImage"
                // src="/assets/images/userdefault2.jpg"
                src={profileimage || "/assets/images/userdefault2.jpg"}
                className="user_img"
                alt=""
              />

              <h4 className="graphic_head">
                Please upload your best photo to feature on winners' graphic.
              </h4>
              <button className="upload_btn" onClick={this.handleClick}>
                {profileimage && (
                  <>
                    <img src="/assets/images/edit.svg" alt="Edit" />
                    Edit Image
                  </>
                )}
                {!profileimage && (
                  <>
                    <img src="/assets/images/btnup.svg" alt="" />
                    Upload Image<span>*</span>
                  </>
                )}
              </button>
              {errors.profileimage && (
                <p
                  style={{
                    color: "red",
                    fontSize: "14px",
                    textAlign: "center",
                    marginTop: "-33px",
                  }}
                >
                  {errors.profileimage}
                </p>
              )}
            </div>
            <div className="">
              <div className="form_label">
                <h5>
                  Name<span>*</span>
                </h5>
                <input
                  onChange={(e) => this.onChange(e, "name")}
                  type="text"
                  name="name"
                  id="userName"
                  placeholder="Name"
                  // className="form-control input_new"
                  value={this.state.name || ""}
                />
                {errors.name && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginTop: "5px",
                    }}
                  >
                    {errors.name}
                  </p>
                )}
              </div>

              <div className="form_label">
                <h5>
                  Mobile Number<span>*</span>
                </h5>
                <input
                  onChange={(e) => this.onChange(e, "mobile")}
                  type="text"
                  minLength={"10"}
                  maxLength={"14"}
                  name="mobile"
                  id="numbers"
                  pattern="[1-9]{1}[0-9]{9}{+}"
                  placeholder="Mobile Number"
                  // className="form-control input_new"
                  value={this.state.mobile || ""}
                />
                {errors.mobile && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginTop: "5px",
                    }}
                  >
                    {errors.mobile}
                  </p>
                )}
              </div>

              <div className="form_label">
                <h5>
                  Address<span>*</span>
                </h5>
                <input
                  type="text"
                  name="address"
                  placeholder="Address"
                  id="residence"
                  value={this.state.address || ""}
                  onChange={(e) => this.onChange(e, "address")}
                />
                {errors.address && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginTop: "5px",
                    }}
                  >
                    {errors.address}
                  </p>
                )}
              </div>

              <div className="form_label">
                <h5>
                  Country<span>*</span>
                </h5>
                <Select
                  styles={customStyles}
                  value={this.state.country}
                  onChange={(e, type) => this.handleChange(e, "country")}
                  className="basic-single"
                  classNamePrefix="select"
                  options={this.state.countryList}
                  placeholder="Select Country"
                />
                {errors.country && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginTop: "5px",
                    }}
                  >
                    {errors.country}
                  </p>
                )}
              </div>

              <div className="form_label">
                <h5>
                  State<span>*</span>
                </h5>
                {this.state.country.value == "India" ? (
                  <Select
                    styles={customStyles}
                    id="state"
                    value={this.state.stateobj}
                    onChange={(e, type) => this.handleChange(e, "stateobj")}
                    className="basic-single"
                    classNamePrefix="select"
                    options={stateList}
                    placeholder="Select State"
                  />
                ) : (
                  <>
                    <input
                      type="text"
                      placeholder="State"
                      name="state"
                      id="state"
                      value={this.state.statename || ""}
                      onChange={(e) => this.onChange(e, "state")}
                    />
                  </>
                )}
                {errors.state && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginTop: "5px",
                    }}
                  >
                    {errors.state}
                  </p>
                )}
              </div>

              <div className="form_label">
                <h5>
                  City<span>*</span>
                </h5>
                <input
                  type="text"
                  name="city"
                  placeholder="City"
                  id="city"
                  value={this.state.city || ""}
                  onChange={(e) => this.onChange(e, "city")}
                />
                {errors.city && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginTop: "5px",
                    }}
                  >
                    {errors.city}
                  </p>
                )}
              </div>

              <div className="form_label">
                <h5>
                  Zip / Postal Code<span>*</span>
                </h5>
                <input
                  type="number"
                  placeholder="Postal Code"
                  name="zip"
                  id="zip"
                  value={this.state.zip || ""}
                  onChange={(e) => this.onChange(e, "zip")}
                />
                {errors.zip && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginTop: "5px",
                    }}
                  >
                    {errors.zip}
                  </p>
                )}
              </div>

              <div className="bjpkaryakrta">
                <h3 className="mkb_head_bjp">BJP Karyakarta's Only</h3>
                <div className="form_label">
                  <h5>Select State</h5>
                  <Select
                    styles={customStyles}
                    value={state}
                    onChange={(e, type) => this.handleChange(e, "state")}
                    className="basic-single"
                    classNamePrefix="select"
                    options={stateList}
                    placeholder="Select State"
                  />
                </div>

                <div className="form_label">
                  <h5>Select Vidhansabha</h5>
                  <Select
                    styles={customStyles}
                    value={vsabha}
                    onChange={(e, type) => this.handleChange(e, "vsabha")}
                    className="basic-single"
                    classNamePrefix="select"
                    options={vsabhaList}
                    placeholder="Select Vidhansabha"
                  />
                </div>

                <div className="form_label">
                  <h5>Booth Number</h5>
                  <input
                    onChange={(e) => this.onChange(e)}
                    type="number"
                    name="boothno"
                    placeholder="Booth Number"
                    className="form-control input_new"
                    value={this.state.boothno || ""}
                  />
                </div>

                {/* Display form errors above submit button */}
                {formErrors.length > 0 && (
                  <div
                    className="form_errors"
                    style={{
                      backgroundColor: "#ffe6e6",
                      border: "1px solid #ff9999",
                      borderRadius: "5px",
                      padding: "10px",
                      marginBottom: "15px",
                    }}
                  >
                    {/* <h6 style={{ color: "#cc0000", margin: "0 0 10px 0" }}>
                      Please fix the following errors:
                    </h6> */}
                    <ul
                      style={{
                        color: "#cc0000",
                        margin: "0",
                        paddingLeft: "20px",
                      }}
                    >
                      {formErrors.map((error, index) => (
                        <li key={index}>{error}</li>
                      ))}
                    </ul>
                  </div>
                )}

                <div className="form_label">
                  <button className="btn btn_orng" onClick={this.onSubmit}>
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {visible && (
          <ImageuploadPopup
            getProfile={this.getProfile}
            hideImgpopup={this.hideImgpopup}
            flagpopup={this.flagpopup}
          />
        )}
      </div>
    );
  }

  onChange = (e, type) => {
    const { name, value } = e.target;

    if (type === "name") {
      this.setState({ name: value }, () => {
        const error = this.validateField("name", value);
        this.setState((prevState) => ({
          errors: { ...prevState.errors, name: error },
        }));
        this.updateFieldStyle("userName", error);
      });
    } else if (type === "mobile") {
      this.setState({ mobile: value }, () => {
        const error = this.validateField("mobile", value);
        this.setState((prevState) => ({
          errors: { ...prevState.errors, mobile: error },
        }));
        this.updateFieldStyle("numbers", error);
      });
    } else if (type === "address") {
      this.setState({ address: value }, () => {
        const error = this.validateField("address", value);
        this.setState((prevState) => ({
          errors: { ...prevState.errors, address: error },
        }));
        this.updateFieldStyle("residence", error);
      });
    } else if (type === "city") {
      this.setState({ city: value }, () => {
        const error = this.validateField("city", value);
        this.setState((prevState) => ({
          errors: { ...prevState.errors, city: error },
        }));
        this.updateFieldStyle("city", error);
      });
    } else if (type === "state") {
      this.setState({ statename: value, adstateid: "" }, () => {
        const error = this.validateField("state", value);
        this.setState((prevState) => ({
          errors: { ...prevState.errors, state: error },
        }));
        this.updateFieldStyle("state", error);
      });
    } else if (type === "zip") {
      this.setState({ zip: value }, () => {
        const error = this.validateField("zip", value);
        this.setState((prevState) => ({
          errors: { ...prevState.errors, zip: error },
        }));
        this.updateFieldStyle("zip", error);
      });
    }

    this.setState({ [name]: value });
  };

  // Helper method to clear all form errors
  clearFormErrors = () => {
    this.setState({
      errors: {
        name: "",
        mobile: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        profileimage: "",
      },
      formErrors: [],
    });
  };
}

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    borderBottom: "1px solid lightgray",
    color: state.isSelected ? "black" : "black",
    backgroundColor: state.isSelected ? "#f8f8f8" : "#fff",
    fontSize: 13,
    minHeight: 35,
  }),
  control: (provided) => ({
    ...provided,
    marginTop: "5%",
    fontSize: 13,
    minWidth: 160,
    backgroundColor: "#f8f8f8",
    //   marginRight:10,
  }),
};
